export default "__VITE_ASSET__BeuPDtzV__"